import Swiper from 'swiper/bundle';

(function ($) {
    let swiper = new Swiper(".section-recent-news .slider-recent-news", {
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
            nextEl: ".section-recent-news .swiper-button-next",
            prevEl: ".section-recent-news .swiper-button-prev",
        },
        scrollbar: {
            el: '.section-recent-news .swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            300: {
                spaceBetween: 16,
            },
            767: {
                spaceBetween: 20,
            },
            1439: {
                spaceBetween: 24,
            },
        }
    });
})(jQuery);